<ion-toolbar>
  <!-- Button aligned to the left -->
  <ion-buttons slot="start">
    <ion-button (click)="exit()" fill="clear">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </ion-buttons>

  <!-- Custom Title with Image and Text -->
  <ion-title class="title">
    {{ 'validationTitle' | translate }}
  </ion-title>
  <ion-buttons slot="end">
  </ion-buttons>

</ion-toolbar>